import React, { useEffect, useRef, useState } from 'react';
import AimdFlowQuestionBase from '../../components/aimdFlowQuestionBase';
import { Box, Button, Stack, Typography } from '@mui/material';
import { ratingsToObj } from '../Results/helperfunctions';

const RevealResultsScreen = () => {
    const pathRef = useRef(null);  // Create a reference for the path element
    const [pathLength, setPathLength] = useState(0);  // State to store the path length
    const [isHideVisibilty, setIsHideVisibilty] = useState(true);  // State to store the path length
    // Using useEffect to capture the path length after the component mounts
    useEffect(() => {
        if (pathRef.current) {
            setPathLength(pathRef.current.getTotalLength());  // Get the total length of the path
        }
    }, []);  // Run once after the component is mounted
    const ratings = {
        low: [0, 90],
        optimal: [90, 120],
        normal: [120, 130],
        elevated: [130, 140],
        high: [140, 180],
    };

    const resultsData = [
        {
            resultItemTile: "Mental Stress",
            resultItemSubInfo: "Level 4",
            resultItemAdvice: "💡 You’ve got low stress- keep it down with exercise.",
            resultItemGraphVal: 10,
            resultItemGraphRightText: "Low",
            resultGraphleftText: "Top 67%",
            resultItemVal: 170,  // Value to be shown on the graph
            ratingsColor: "#F34848",
            ratings: {
                low: [0, 90],
                optimal: [90, 120],
                normal: [120, 130],
                elevated: [130, 140],
                high: [140, 180],
            }
        },
        {
            resultItemTile: "Blood Pressure",
            resultItemSubInfo: "Level 4",
            resultItemAdvice: "💡 You’ve got low stress- keep it down with exercise.",
            resultItemGraphVal: 10,
            resultItemGraphRightText: "Low",
            resultGraphleftText: "Top 67%",
            resultItemVal: 100,  // Value to be shown on the graph
            ratingsColor: "#F2D53A",
            ratings: {
                low: [0, 90],
                optimal: [90, 120],
                normal: [120, 130],
                elevated: [130, 140],
                high: [140, 180],
            }
        },
        {
            resultItemTile: "Diabetes Risk",
            resultItemSubInfo: "Level 4",
            resultItemAdvice: "💡 You’ve got low stress- keep it down with exercise.",
            resultItemGraphVal: 10,
            resultItemGraphRightText: "Low",
            resultGraphleftText: "Top 67%",
            resultItemVal: 50,  // Value to be shown on the graph
            ratingsColor: "#F2D53A",
            ratings: {
                low: [0, 90],
                optimal: [90, 120],
                normal: [120, 130],
                elevated: [130, 140],
                high: [140, 180],
            }

        },
    ];

    const calculateCx = (resultItemVal, ratings) => {
        // Find the corresponding range for resultItemVal
        const matchedRange = Object.values(ratings).find(([min, max]) => resultItemVal >= min && resultItemVal <= max);
        if (matchedRange) {
            const [minRating, maxRating] = matchedRange;

            // Total path length (as set in state)
            const totalPathLength = pathLength;

            // The path is 115 units long, and we scale the value based on this
            const minX = 2;  // Start of the path
            const maxX = 115; // End of the path

            // Scale the X position based on resultItemVal and ratings range
            const scaledX = ((resultItemVal - minRating) / (maxRating - minRating)) * (maxX - minX) + minX;

            return scaledX;
        }

        return 2;  // Fallback position if no match found
    };

    const calculateCy = (cx) => {
        if (pathRef.current && pathLength > 0) {
            const path = pathRef.current;
            const point = path.getPointAtLength((cx / 115) * pathLength);
            return point.y;  // Return the y-coordinate from the path
        }

        return 45;  // Fallback if no valid position
    };

    const getRatingText = (resultItemVal, ratings) => {
        // Find the corresponding range for resultItemVal
        for (const [key, [min, max]] of Object.entries(ratings)) {
            if (resultItemVal >= min && resultItemVal <= max) {
                return key.charAt(0).toUpperCase() + key.slice(1);  // Capitalize the first letter
            }
        }
        return "Unknown";  // If no range matches
    };

    return (
        <AimdFlowQuestionBase IsShowBackIcon="true" isShowMenuIcon="true" isShowStepper={false} isBottomLogoVisible={false}>
            <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                <Typography sx={{ color: "#000", fontSize: "30px", fontWeight: 700 }}>
                Reveal Your Results 👀
                </Typography>
                <Typography sx={{ color: "#000", fontSize: "16px", fontWeight: 600, textAlign: "center" }}>
                Become more fit, healthy, and attractive with personalized advice from AI-MD. 
                </Typography>
                <Stack sx={{ marginTop: "50px" }}>
                    {resultsData && resultsData.map((data, index) => (
                        <Box
                            key={index}
                            sx={{
                                maxWidth: "334px",
                                display: "flex",
                                marginBottom: "14px",
                                flexDirection: "column",
                                boxSizing: "border-box",
                                padding: "8px",
                                width: "100%",
                                minHeight: "133px",
                                borderRadius: "15px",
                                background: "linear-gradient(180deg, #FCFCFC 0%, #E4E3E3 100%)",
                                boxShadow: "0px 230px 64px 0px rgba(0, 0, 0, 0.00), 0px 147px 59px 0px rgba(0, 0, 0, 0.01), 0px 83px 50px 0px rgba(0, 0, 0, 0.05), 0px 37px 37px 0px rgba(0, 0, 0, 0.09), 0px 9px 20px 0px rgba(0, 0, 0, 0.10)"
                            }}>
                            <Stack sx={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                alignItems: "center"
                            }}>
                                <Box>
                                    <Typography sx={{ color: "#000", fontSize: "17px", fontWeight: 600 }}>
                                        {data.resultItemTile}
                                    </Typography>
                                    <Typography sx={{ color: "#000", fontSize: "25px", fontWeight: 700, filter: isHideVisibilty ? "blur(10px)" : "blur(0px)" }}>
                                        {data.resultItemSubInfo}
                                    </Typography>
                                </Box>

                                <Box>
                                    <Stack >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="117" height="47" viewBox="0 0 117 47" fill="none">
                                            <path
                                                ref={pathRef}  // Reference the path element
                                                d="M2 45V45C21.9554 42.2268 39.3601 30.0274 48.774 12.2149L51.891 6.31717C55.1715 0.110054 64.0099 -0.0362423 67.494 6.05891L73.2738 16.1702C82.0967 31.6052 97.4419 42.2076 115 45V45"
                                                stroke="#A1A0A0"
                                                strokeOpacity="0.54"
                                                strokeWidth="3"
                                                strokeLinecap="round"
                                            />

                                            <circle

                                                key={index}
                                                cx={calculateCx(data.resultItemVal, data.ratings)}  // Adjust the horizontal position dynamically
                                                cy={calculateCy(calculateCx(data.resultItemVal, data.ratings))}  // Adjust the vertical position based on path
                                                r="3"  // Circle radius
                                                fill={data.ratingsColor}  // Circle color
                                            />

                                        </svg>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="117" height="4" viewBox="0 0 117 4" fill="none">
                                            <path d="M2 2L115 2.00001" stroke={data.ratingsColor} stroke-width="3" stroke-linecap="round" />
                                        </svg>
                                        <Box sx={{
                                            display: "flex",
                                            justifyContent: "space-between",

                                        }}>
                                            <Typography sx={{ textAlign: "start", fontSize: "12px", fontWeight: 600, filter: isHideVisibilty ? "blur(10px)" : "blur(0px)" }}>
                                                {data.resultGraphleftText}
                                            </Typography>
                                            <Typography sx={{ textAlign: "end", fontSize: "12px", fontWeight: 600 }}>
                                                {getRatingText(data.resultItemVal, data.ratings)}
                                            </Typography>
                                        </Box>
                                    </Stack>
                                </Box>
                            </Stack>
                            <Typography sx={{
                                color: "#000",
                                fontSize: "12px",
                                fontWeight: 500,
                                filter: isHideVisibilty ? "blur(6px)" : "blur(0px)"
                            }}>
                                {data.resultItemAdvice}
                            </Typography>
                        </Box>
                    ))}
                    <Typography sx={{
                        color: "#000",
                        fontSize: "13px",
                        fontWeight: 600,
                        textAlign: "center",
                        width: "100%"
                    }}>
                        👇 421 people just revealed their result👇
                    </Typography>
                    <Button
                        sx={{
                            borderRadius: '40px', // Rounded corners
                            background: '#72D8DA', // Background color
                            boxShadow: '0px 35px 35px 0px rgba(0, 0, 0, 0.09), 0px 9px 19px 0px rgba(0, 0, 0, 0.10)', // Box shadow
                            width: '320px', // Width of the button
                            height: '65px', // Height of the button
                            flexShrink: 0, // Prevent shrinking
                            color: "white",
                            fontSize: "20px",
                            fontWeight: 600,
                            '&:hover': {
                                background: '#5fb8b8', // Adjust background on hover for better UI feedback
                            },
                            marginTop: { lg: "20px", md: "20px", sm: "20px", xs: "20px" }
                        }}
                    >
                        Get AI-MD Pro 💪🏻
                    </Button>
                    <Typography sx={{
                        color: "#A1A0A0",
                        textAlign: "center",
                        fontSize: "17px",
                        fontWeight: 600,
                        marginTop: "10px"
                    }}>
                        Maybe later
                    </Typography>
                </Stack>
            </Box >
        </AimdFlowQuestionBase >
    );
};

export default RevealResultsScreen;
